import React from 'react';
import PropTypes from 'prop-types';

import './Message.scss';
import FontAwesome from 'react-fontawesome';

const MessageMap = {
    error: {
        icon: 'times',
        text: 'Error'
    },
    warning: {
        icon: 'exclamation',
        text: 'Warning'
    },
    info: {
        icon: 'info',
        text: 'Information'
    },
    success: {
        icon: 'check',
        text: 'Success'
    }
};

const Message = ({ type, message, children, ...otherProps }) => {
    return (
        <div className={`${type} message flex fixed flex-row`}>
            <FontAwesome className="fa-layers icon" name={MessageMap[type].icon} />
            <span className="messsage-text" {...otherProps}>
                <strong>{MessageMap[type].text}.</strong>
                <span>{message || children}</span>
            </span>
        </div>
    );
};

Message.prototype = {
    type: PropTypes.oneOf(['error', 'warning', 'info', 'success'])
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/Message/Message.jsx